/** Maximum accepted number of KKS rows in the imported IBL */
export const IBL_IMPORT_MAX_KKS_COUNT = 2000;
